import {Injectable} from 'ng-metadata/core';
import {AbstractRequest} from '../abstractRequest';
import {FormBuilderEnums} from '../../../../../../../infra/formBuilder/formBuilder.service';
import { MappingTablesCache } from '../../../../../../../mappingTablesCache/mappingTablesCache.service';
import { ConfigurationUtil } from '../../../../../../../nddUtils/configurationUtil.service';

const getValue = require('lodash/get');

@Injectable()
export class AlmaPurchaseRequest extends AbstractRequest {
    constructor(
        private mappingTablesCache : MappingTablesCache,
        private configurationUtil:ConfigurationUtil){
            
        super();
        this.formFields = [
        {
            key: 'mmsId',
            name: 'mmsId',
            label: '',
            mandatory: false,
            valuePath: 'mmsId',
            existingPath: 'mmsId',
            fieldType: FormBuilderEnums.FIELD_TYPE.INTERNAL,
            uiType: FormBuilderEnums.UI_TYPE.HIDDEN
        },
        {
                key: 'citationType',
                name: 'citationType',
                label: 'almaPurchaseRequest.citationType',
                value: 'book',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                existingPath: 'dummyPath',
                valuePath: 'citationType',
                uiType: FormBuilderEnums.UI_TYPE.RADIO_BUTTON,
                populator:  {
                    params:     {
                        defaultValuePath: 'citationType'
                    }
                },
                options:[
                    {
                        label:'almaPurchaseRequest.book',
                        value:'book'
                    },
                    {
                        label:'almaPurchaseRequest.journal',
                        value:'journal'
                    }
                ],
                events: {
                    onClick: this.onClick.bind(this),
                    params: []
                }

            },
            {
                key: 'materialType',
                name: 'materialType',
                label: 'almaPurchaseRequest.materialType',
                value: 'default',                
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                existingPath: 'dummyPath',
                valuePath: 'materialType',
                uiType: FormBuilderEnums.UI_TYPE.RADIO_BUTTON,
                populator:  {
                    params:     {                    	
                        defaultValuePath: 'materialType'
                    },
                    deleteFromFormDataIfHidden: 'true'
                },
                options:[                
                    {
                        label:'almaPurchaseRequest.materialTypeElectronic',
                        value:'Electronic'
                    },
                    {
                        label:'almaPurchaseRequest.materialTypePhysical',
                        value:'Physical'
                    }
                ],
                events: {
                    onClick: this.onClick.bind(this),
                    params: []
                }
            }, 
             {              
                key: 'electronicChooseType',
                name: 'electronicChooseType',
                label: 'almaPurchaseRequest.chooseType',                
                mandatory: false,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                existingPath: 'dummyPath',
                valuePath: 'electronicChooseType',
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                 dependOn: {                 
                 	key : 'materialType',
                 	value: ['Electronic'],
                 	showIfFieldByKeyDoesntExist:'false'
                },               
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                },
				populator:  {
                     func: this.itemsArrayPopulator.bind(this),
                    params: {
                        key: 'key',
                        value: 'value',
                        defaultValuePath:'defaultElectronicChooseType'
                    }
                 }                 
            },
              {
                key: 'physicalChooseType',
                name: 'physicalChooseType',
                label: 'almaPurchaseRequest.chooseType',                
                mandatory: false,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,   
                existingPath: 'dummyPath',
                valuePath: 'physicalChooseType',          
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                 dependOn: {
                 	key : 'materialType',
                 	value: ['Physical'],
                 	showIfFieldByKeyDoesntExist:'false'
                },               
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                },
				populator:  {
                     func: this.itemsArrayPopulator.bind(this),
                    params: {
                        key: 'key',
                        value: 'value',
                        defaultValuePath:'defaultPhysicalChooseType'
                    }
                 }                 
            },                           
             {
                key: 'title',
                name: 'title',
                label: 'almaPurchaseRequest.title',
                mandatory: true,
                valuePath: 'title',
                existingPath: 'title',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {
                     behavior: FormBuilderEnums.BEHAVIOR.VISIBLE_DISABLED,
                     key: 'mmsId',
                     isExists: false
                }
            },
             {
                key: 'author',
                name: 'author',
                label: 'almaPurchaseRequest.author',
                mandatory: false,
                valuePath: 'author',
                existingPath: 'author',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {
                     behavior: FormBuilderEnums.BEHAVIOR.VISIBLE_DISABLED,
                     key: 'mmsId',
                     isExists: false
                }
            },
             {
                key: 'edition',
                name: 'edition',
                label: 'almaPurchaseRequest.edition',
                mandatory: false,
                valuePath: 'edition',
                existingPath: 'edition',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {
                     behavior: FormBuilderEnums.BEHAVIOR.VISIBLE_DISABLED,
                     key: 'mmsId',
                     isExists: false
                }
            },
              {
                key: 'isbn',
                name: 'isbn',
                label: 'almaPurchaseRequest.isbn',
                mandatory: false,
                valuePath: 'isbn',
                existingPath: 'isbn',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                validPattern: '^[0-9xX]+(-[0-9xX]+?)*$',
                dependOn: [
                    {key : 'citationType', value: 'book'},
                    {
                        behavior: FormBuilderEnums.BEHAVIOR.VISIBLE_DISABLED,
                        key: 'mmsId',
                        isExists: false
                    }
                ]
            },
            {
                key: 'issn',
                name: 'issn',
                label: 'almaPurchaseRequest.issn',
                mandatory: false,
                valuePath: 'issn',
                existingPath: 'issn',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: [
                    {key : 'citationType', value: 'journal'},
                    {
                        behavior: FormBuilderEnums.BEHAVIOR.VISIBLE_DISABLED,
                        key: 'mmsId',
                        isExists: false
                    }
                ]
            },
            {
                key: 'lccNumber',
                name: 'lccNumber',
                label: 'almaPurchaseRequest.lccNumber',
                mandatory: false,
                valuePath: 'lccNumber',
                existingPath: 'lccNumber',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {
                    behavior: FormBuilderEnums.BEHAVIOR.VISIBLE_DISABLED,
                    key: 'mmsId',
                    isExists: false
                }
            },
            {
                key: 'oclcNumber',
                name: 'oclcNumber',
                label: 'almaPurchaseRequest.oclcNumber',
                mandatory: false,
                valuePath: 'oclcNumber',
                existingPath: 'oclcNumber',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {
                    behavior: FormBuilderEnums.BEHAVIOR.VISIBLE_DISABLED,
                    key: 'mmsId',
                    isExists: false
                }
            },
            {
                key: 'publisher',
                name: 'publisher',
                label: 'almaPurchaseRequest.publisher',
                mandatory: false,
                valuePath: 'publisher',
                existingPath: 'publisher',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {
                    behavior: FormBuilderEnums.BEHAVIOR.VISIBLE_DISABLED,
                    key: 'mmsId',
                    isExists: false
                }
            },
            {
                key: 'publication_year',
                name: 'publication_year',
                label: 'almaPurchaseRequest.publication_year',
                mandatory: false,
                valuePath: 'publication_year',
                existingPath: 'publication_year',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {
                    behavior: FormBuilderEnums.BEHAVIOR.VISIBLE_DISABLED,
                    key: 'mmsId',
                    isExists: false
                }
            },
            {
                key: 'place_of_publication',
                name: 'place_of_publication',
                label: 'almaPurchaseRequest.place_of_publication',
                mandatory: false,
                valuePath: 'place_of_publication',
                existingPath: 'place_of_publication',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {
                    behavior: FormBuilderEnums.BEHAVIOR.VISIBLE_DISABLED,
                    key: 'mmsId',
                    isExists: false
                }
            },
            {
                key: 'volume',
                name: 'volume',
                label: 'almaPurchaseRequest.volume',
                mandatory: false,
                valuePath: 'volume',
                existingPath: 'volume',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {
                    behavior: FormBuilderEnums.BEHAVIOR.VISIBLE_DISABLED,
                    key: 'mmsId',
                    isExists: false
                }
            },
            {
                key: 'requesterNotes',
                name: 'requesterNotes',
                label: 'almaPurchaseRequest.requesterNotes',
                mandatory: false,
                valuePath: 'requesterNotes',
                existingPath: 'requesterNotes',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'requesterNotesAdditionalInfo',
                name: 'requesterNotesAdditionalInfo',
                label: 'almaPurchaseRequest.requesterNotesAdditionalInfo',
                mandatory: false,
                valuePath: 'requesterNotesAdditionalInfo',
                existingPath: 'requesterNotesAdditionalInfo',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN
            },
            {
                key: 'purchaseRequestLibrary',
                name: 'purchaseRequestLibrary',
                label: 'almaPurchaseRequest.library',
                mandatory: false,
                valuePath: 'purchaseRequestLibrary',
                existingPath: 'purchaseRequestLibrary',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func: this.purchaseRequestLibraryArrayPopulator.bind(this),
                    params: {
                        key: 'key',
                        value: 'value'
                    }
                }
            },
            {
                key: 'genericCheckBox',
                name: 'genericCheckBox',
                label: '',
                value: '',
                existingPath: 'dummyPath',
                mandatory: false,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
                populator:  {
                    deleteFromFormDataIfHidden: 'true'
                },
                options:[
                    {
                        label: 'almaPurchaseRequest.genericCheckBox',
                        value:'N'
                    }
                ]
            }
        ];
    }

    private purchaseRequestLibraryArrayPopulator(field, form, formData, data): void{
        if(getValue(data, '[0].purchaseRequestLibrary')) {
            data[0].purchaseRequestLibrary = data[0].purchaseRequestLibrary
                .sort((a,b) => a.value.toLowerCase().localeCompare(b.value.toLowerCase()));
        }
        this.itemsArrayPopulator(field, form, formData, data);
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestTypes/alma/almaPurchaseRequest.ts